import { Form } from "../components"
import CRMCheckOut from "./components/CRMCheckOut"
import CRMHero from "./components/CRMHero"
import CRMLiquidity from "./components/CRMLiquidity"
import CRMSlides from "./components/CRMSlides"

export default function CRM() {
  return (
    <>
      <section>
        <CRMHero />
        <CRMSlides />
        <CRMLiquidity />
        <CRMCheckOut />

        <div className="bg-blue py-10 px-5 lg:py-20 2xl:px-0">
          <article className="xl:max-w-6xl xl:mx-auto">
            <h2 className="text-white text-3xl lg:text-5xl mb-5 lg:mb-10 lg:leading-snug">
              Are you ready to get started? Contact us today{" "}
              <span className="md:block">
                for your Back Office and Trading Platform
              </span>
              <span className="md:block">package!</span>
            </h2>
            <Form />
          </article>
        </div>
      </section>
    </>
  )
}
